// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"c-PaymentLogosBar__wrapper","logo":"c-PaymentLogosBar__logo"};